import { Middleware } from '@nuxt/types'

const Permissions: Middleware = ({ $auth, route }) => {
  console.log(route)
  $auth.permissionRouteGuard('subscription')
}

export default Permissions
